@if (_visible$ | async) {
  <div class="app-copilot-ask-launcher">
    <app-button
      type="primary"
      size="large"
      [matTooltip]="'pages.copilot.askLauncher.tooltip' | translate"
      matTooltipPosition="left"
      matTooltipShowDelay="300"
      (click)="_open()">
      <app-svg
        [icon]="'AI_16'"
        subType="inverse"
        [disabledHover]="true"
        class="mr-8">
      </app-svg>
      <span>{{ 'pages.copilot.askLauncher.label' | translate }}</span>
    </app-button>
  </div>
}
